import {noop} from '@github-ui/noop'
import type {RelayCompat} from '@github-ui/server-persisted-queries/relay-compat'
import {LinkExternalIcon} from '@primer/octicons-react'

import {IssueTemplateItem} from './IssueTemplateItem'
import type {RepositoryContactLinkNode} from './template-list-query-types'

// RELAY-CLEANUP(TemplateList): widens nullable fields so the still-Relay parent data is assignable.
// Remove when TemplateList leaves Relay.
export type ExternalLinkTemplateRowFragment = RelayCompat<Pick<RepositoryContactLinkNode, 'about' | 'url' | 'name'>>

type ExternalLinkTemplateRowProps = {
  repositoryContactLink: ExternalLinkTemplateRowFragment
}

export const ExternalLinkTemplateRow = ({repositoryContactLink}: ExternalLinkTemplateRowProps): React.ReactElement => {
  return (
    <IssueTemplateItem
      filename={repositoryContactLink.name}
      onTemplateSelected={noop}
      name={repositoryContactLink.name}
      link={repositoryContactLink.url}
      about={repositoryContactLink.about}
      externalLink
      trailingIcon={<LinkExternalIcon />}
    />
  )
}
